import { Switch as MuiSwitch } from '@material-ui/core';
import { Box } from 'reflexbox';
import React from 'react';
import styled, { css } from 'styled-components';

const Switch = ({
  labelSize = 17,
  label,
  value,
  onChange,
  checked,
  disabled,
  reverseOrder,
  withPadding = true,
  inputProps,
  ...otherProps
}) => (
  <Container $reverseOrder={reverseOrder} {...otherProps}>
    {label && (
      <Label disabled={disabled} size={labelSize}>
        {label}
      </Label>
    )}
    <Box>
      <StyledSwitch
        $withPadding={withPadding}
        disabled={disabled}
        onChange={onChange}
        value={value}
        checked={checked}
        inputProps={typeof label === 'string' ? { 'aria-label': label, ...inputProps } : inputProps}
      />
    </Box>
  </Container>
);

const getLabelStyles = (props) => {
  const { size } = props;
  let fontWeight = 100;
  let styles = '';

  if (size > 20) {
    fontWeight = 700;
  }

  styles += `font-size: ${props.size}px; font-weight: ${fontWeight}`;

  return styles;
};

const Container = styled(Box)`
  display: flex;
  ${(props) => props.$reverseOrder && `flex-direction: row-reverse;`}
  align-items: center;
  justify-content: space-between;
`;

const StyledSwitch = styled(MuiSwitch)`
  ${(props) => !props.$withPadding &&
    css`
      && > span:nth-child(1) {
        height: auto;
      }
    `}
`;

const Label = styled.p`
  margin: 0;
  ${getLabelStyles}
`;

export default Switch;
